import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CoCompanyService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/co-companies', params);
    }

    store(body: any) {
        return super.post(`/co-companies`, body);
    }

    edit(coCompanyId: number) {
        return super.get(`/co-companies/${coCompanyId}/edit`);
    }

    update(coCompanyId: number, body: any) {
        return super.put(`/co-companies/${coCompanyId}`, body);
    }

    destroy(coCompanyId: number) {
        return super.delete(`/co-companies/${coCompanyId}`);
    }

    select(params: any = {}) {
        return super.get(`/co-companies/select`, params);
    }

    children(coCompanyId: number) {
        return super.get(`/co-companies/${coCompanyId}/children`);
    }

    createFind(params: any) {
        return super.get(`/co-companies/create/find`, params);
    }
}
